import styled from "styled-components";

import { ChangeValue } from "@similarweb/ui-components";

import { Favicon } from "pro-features/components/Chart/src/dataLabels/favicon/Favicon";
import { RegionalDomainsFavicon, SegmentFavicon } from "pro-features/components/Chart/src/dataLabels/favicon/SegmentFavicon";

const CategoryValueChangeWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
`;

type IconFormat = "none" | "regional" | "segment";

interface Props {
    valueChange: string;
    iconSrc: string;
    iconFormat: IconFormat;
    isPreviousValueEmpty?: boolean;
}

export const MarketSharesPeriodOverPeriodCategoryValueChange = ({
    valueChange,
    iconSrc,
    iconFormat = "none",
    isPreviousValueEmpty = false,
}: Props) => {
    let icon = null;

    if (iconSrc) {
        if (iconFormat === "segment") {
            icon = <SegmentFavicon src={iconSrc} />;
        } else if (iconFormat === "regional") {
            icon = <RegionalDomainsFavicon src={iconSrc} />;
        } else {
            icon = <Favicon src={iconSrc} />;
        }
    }

    return (
        <CategoryValueChangeWrapper>
            <ChangeValue
                value={isPreviousValueEmpty ? "-" : valueChange}
                unsigned={isPreviousValueEmpty}
                isDecrease={Number(valueChange.replace(/[^0-9.-]/g, "")) < 0}
            />
            {icon}
        </CategoryValueChangeWrapper>
    );
};
